import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IReleaseEntry, IReleaseNotes, ILangItem } from "@common/types/sharedTypes";
import { SXModalBase } from "./SXModal";
import { ReleaseNoteText } from "./ReleaseNoteText";

interface ReleaseNotesModalProps {
  close: () => void;
  show: boolean;
  notes?: IReleaseNotes;
}

const getNoteText = (note: ILangItem, lang: string) => {
  const key = lang as keyof ILangItem;
  return note[key] ?? note.en;
};

export const ReleaseNotesModal = ({ close, show, notes }: ReleaseNotesModalProps) => {
  const { t, i18n } = useTranslation();

  return (
    <SXModalBase
      header={t("release_notes")}
      show={show}
      size="lg"
      close={close}
      body={
        <div>
          {notes?.releases.map((release: IReleaseEntry) => (
            <ul key={release.version}>
              <li>
                <strong>
                  {release.version} ({release.date})
                </strong>
                <ul>
                  {release.notes.map((note, index) => (
                    <li key={`${release.version}-${index}`}>
                      <ReleaseNoteText text={getNoteText(note, i18n.language)} />
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          ))}
        </div>
      }
      footer={
        <Button className="modal-btn" onClick={close}>
          {t("buttons.close")}
        </Button>
      }
    />
  );
};
